<p-card [style]="{ width: '50%' }" header="Dashboard">
  @if (hasOnlyUserRole()) {
    <span translate>DASHBOARD.NO_ACCESS</span>
  } @else {
    <span translate>DASHBOARD.WELCOME</span>
  }
</p-card>
